import {isNotEmpty} from 'ramda';

import {PriceReportType} from '../types/PriceReportType';
import {getPrice} from './getPrice';
import {getPriceChanges, VehiclePriceChangeSource} from './getPriceChanges';

export type VehiclePriceChangeDirection = 'increased' | 'decreased';

export function getVehiclePriceChangeDirection(
  vehicle: VehiclePriceChangeSource,
  priceReport: PriceReportType
): VehiclePriceChangeDirection | null {
  const priceChanges = getPriceChanges(vehicle);

  if (!isNotEmpty(priceChanges) || priceChanges.length < 2) {
    return null;
  }

  const previousPriceChange = priceChanges.at(-2);

  if (!previousPriceChange) {
    return null;
  }

  const vehiclePrice = getPrice(vehicle, priceReport);
  const priceDifference = previousPriceChange.price - vehiclePrice;

  if (priceDifference > 0) {
    return 'decreased';
  }

  if (priceDifference < 0) {
    return 'increased';
  }

  return null;
}
